import 'twin.macro';
import React, { useState } from 'react';
import { useAuth } from '@teetsh/app/src/containers/App/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import Button from 'components/Buttons/Button';
import { routes } from 'containers/routes';
import { useTranslation } from 'react-i18next';

interface Props {
  sequenceTemplateId?: string;
  edtTemplateId?: string;
  programmationTemplateId?: string;
  sequenceTemplateDocumentId?: string;
  edtTemplateDocumentId?: string;
  programmationTemplateDocumentId?: string;
  parrainageToken?: string;
  shareToken?: string;
  shareEntityId?: string;
  shareEntityType?: string;
}

export function RegisterToGoogleButton(props: Props) {
  const { registerGoogle } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation(['onboarding', 'common']);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  if (isSubmitting) {
    return <Button loading fill large tw="mt-2" />;
  }
  return (
    <>
      {error !== '' && (
        <div tw="text-sm font-semibold text-danger-quiet">{error}</div>
      )}
      <GoogleLogin
        text="signup_with"
        locale={t('common:locale.short')}
        onError={() => {
          setIsSubmitting(false);
        }}
        onSuccess={(infos: CredentialResponse) => {
          setError('');
          setIsSubmitting(true);
          registerGoogle({
            tokenId: infos.credential as string,
            edtTemplateId: props.edtTemplateId,
            sequenceTemplateId: props.sequenceTemplateId,
            programmationTemplateId: props.programmationTemplateId,

            edtTemplateDocumentId: props.edtTemplateDocumentId,
            sequenceTemplateDocumentId: props.sequenceTemplateDocumentId,
            programmationTemplateDocumentId:
              props.programmationTemplateDocumentId,
            shareToken: props.shareToken,
            shareEntityId: props.shareEntityId,
            shareEntityType: props.shareEntityType,
            parrainageToken: props.parrainageToken,
          })
            .then(() => {
              setIsSubmitting(false);
              navigate(routes.demarrage);
            })
            .catch(err => {
              setIsSubmitting(false);
              if (err?.response?.status === 409) {
                setError(t('onboarding:signup.alreadyUsedEmail'));
                return;
              }
              setError(t('common:messages.genericError'));
            });
        }}
      />
    </>
  );
}
